var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 256 256",
    style: {
      msTransform: "rotate(360deg)",
      WebkitTransform: "rotate(360deg)",
      transform: "rotate(360deg)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M212 80a28 28 0 1 0 28 28a28.1 28.1 0 0 0-28-28Zm0 40a12 12 0 1 1 12-12a12 12 0 0 1-12 12ZM72 108a28 28 0 1 0-28 28a28.1 28.1 0 0 0 28-28Zm-28 12a12 12 0 1 1 12-12a12 12 0 0 1-12 12Zm48-32a28 28 0 1 0-28-28a28.1 28.1 0 0 0 28 28Zm0-40a12 12 0 1 1-12 12a12 12 0 0 1 12-12Zm72 40a28 28 0 1 0-28-28a28.1 28.1 0 0 0 28 28Zm0-40a12 12 0 1 1-12 12a12 12 0 0 1 12-12Zm23.1 100.8a35.3 35.3 0 0 1-16.9-21.1a43.9 43.9 0 0 0-84.4 0A35.5 35.5 0 0 1 69 148.8A40 40 0 0 0 88 224a40.5 40.5 0 0 0 15.5-3.1a64.2 64.2 0 0 1 48.9-.1A39.6 39.6 0 0 0 168 224a40 40 0 0 0 19.1-75.2ZM168 208a24.1 24.1 0 0 1-9.5-1.9A78.7 78.7 0 0 0 128 200a79.9 79.9 0 0 0-30.6 6.1A23.2 23.2 0 0 1 88 208a24 24 0 0 1-11.3-45.2a51.1 51.1 0 0 0 24.4-30.6a28 28 0 0 1 53.8 0a51.1 51.1 0 0 0 24.4 30.6h.1A24 24 0 0 1 168 208Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaw);
export default __webpack_public_path__ + "static/media/paw.fd7d9c0cda9395e7e965e4bc1818b8aa.svg";
export { ForwardRef as ReactComponent };